import { render } from "./FlightBookingView.vue?vue&type=template&id=619d9e74"
import script from "./FlightBookingView.vue?vue&type=script&lang=js"
export * from "./FlightBookingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__